import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { redirect_url } from 'src/environments/environment';
@Component({
	selector: 'app-register-complete',
	templateUrl: './register-complete.component.html',
	styleUrls: ['./register-complete.component.scss']
})

export class RegisterCompleteComponent implements OnInit {
	timeLeft: number = 5;
	interval:any ;
	registeredEmail: string;
	subdomain: string;

	constructor(
		private router:Router,
		private route: ActivatedRoute
	) { }

	ngOnInit(): void {
		this.subdomain = this.route.snapshot.params['subdomain'] + redirect_url;
		this.registeredEmail = this.route.snapshot.params['email'];
		this.interval = setInterval(() => {
			if(this.timeLeft > 0) {
				this.timeLeft--;
			} else {
				// put your path in ''
				window.location.href = "https://" + this.route.snapshot.params['subdomain'] + redirect_url +"?token="+this.route.snapshot.params['token']
			}
		},1000)
	}
}
